import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const handleSubmit = async () => {
    if (!token) {
      setMessage("Manjka token!");
      return;
    }

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/resetPassword.php`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      },
    );

    const data = await res.json();

    if (data.success) {
      setMessage("Geslo uspešno spremenjeno!");

      // po 2s nazaj na login
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } else {
      setMessage("Napaka pri spremembi gesla");
    }
  };

  return (
    <div className="h-screen flex items-center justify-center flex-col gap-4">
      <h1 className="text-2xl font-bold">Nastavi novo geslo</h1>

      <input
        className="border p-2"
        type="password"
        placeholder="Novo geslo"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button
        className="bg-primary text-white px-4 py-2 rounded"
        onClick={handleSubmit}
      >
        Shrani
      </button>

      {message && <p>{message}</p>}
    </div>
  );
};

export default ResetPassword;
